import React from 'react';
import styles from './style.module.css';

export type ButtonProps = {
  selected: boolean;
  error?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ChoiceButton: React.FC<ButtonProps> = ({
  selected = false,
  error,
  children,
  ...props
}) => {
  return (
    <button
      className={`${styles.button} ${selected && styles.selected}`}
      {...props}
    >
      {/* content div is necessary for double border on focus */}
      <div className={styles.content}>{children}</div>
    </button>
  );
};

export default ChoiceButton;
